import { pixelEventFields } from '../pixelAuditLinkFormat';

export function transformAdriverUrl(url: string, name: string): string {
  let transformedUrl = url.trim();

  // Определяем тип поля
  const isPixel = [
    'click_audit_pixel',
    'pixel',
    'pixel_additional',
    'pixel_additional2',
  ].includes(name);
  const isLink = name === 'link';

  // Проверяем, является ли это ссылкой Adriver нужного типа
  const isAdriverClick = url.includes('ad.adriver.ru/cgi-bin/click.cgi');
  const isAdriverRle = url.includes('ad.adriver.ru/cgi-bin/rle.cgi');

  // Для pixel поля - обрабатываем только rle.cgi ссылки
  if (isPixel) {
    if (!isAdriverRle) {
      return transformedUrl; // Не rle.cgi ссылка для pixel поля
    }

    // Общие преобразования для ВСЕХ Adriver ссылок (включая pixel)
    // 1. Замена exss с пустым значением на exss={RID}
    transformedUrl = transformedUrl.replace(
      /&exss=([^&]*)/g,
      (match, value) => {
        if (value === '' || value === '&' || value === undefined) {
          return '&exss={RID}';
        }
        return match; // Оставляем как есть, если есть значение
      },
    );

    // Если exss нет совсем, добавляем его
    if (!transformedUrl.includes('exss=')) {
      const separator = transformedUrl.includes('?') ? '&' : '?';
      transformedUrl += `${separator}exss={RID}`;
    }

    // 2. Замена rnd на rnd={RND}
    transformedUrl = transformedUrl.replace(/&rnd=([^&]*)/g, '&rnd={RND}');

    // 3. Добавление дополнительных параметров exs0-exs3
    const additionalParams =
      '&exs0=mediasniper&exs1={PUBLISHER}&exs2={S_DMN_OR_APP_ENC}&exs3={SRC_XXH64}';

    // Проверяем, есть ли уже эти параметры
    if (!transformedUrl.includes('exs0=')) {
      transformedUrl += additionalParams;
    }

    return transformedUrl;
  }

  // Для link поля - обрабатываем только click.cgi ссылки
  if (isLink) {
    if (!isAdriverClick) {
      return transformedUrl; // Не click.cgi ссылка для link поля
    }

    // КОНКРЕТНЫЕ ПРЕОБРАЗОВАНИЯ ТОЛЬКО ДЛЯ LINK:

    // 1. Удаляем erid=[erir_token] если уже есть erid={ERID}
    const hasEridToken = transformedUrl.includes('erid=[erir_token]');
    const hasEridVariable = transformedUrl.includes('erid={ERID}');

    if (hasEridVariable && hasEridToken) {
      // Удаляем только erid=[erir_token], оставляем erid={ERID}
      transformedUrl = transformedUrl.replace(/&erid=\[erir_token\]/g, '');

      // Если после удаления осталось &&, убираем лишний &
      transformedUrl = transformedUrl.replace(/&&/g, '&');

      // Если получилось ?& в начале параметров, исправляем
      if (transformedUrl.includes('?&')) {
        transformedUrl = transformedUrl.replace(/\?&/, '?');
      }
    }

    // 2. Заменяем rnd на rnd={RND}
    transformedUrl = transformedUrl.replace(/&rnd=([^&]*)/g, '&rnd={RND}');

    // 3. Добавляем недостающие параметры, если их нет
    const paramsToAdd = [
      'exs0=mediasniper',
      'exs1={PUBLISHER}',
      'exs2={S_DMN_OR_APP_ENC}',
      'exs3={SRC_XXH64}',
      'custom=11={TR_KEY}',
    ];

    // Проверяем каждый параметр и добавляем только если его нет
    paramsToAdd.forEach((param) => {
      const paramName = param.split('=')[0];
      if (!transformedUrl.includes(`${paramName}=`)) {
        const separator = transformedUrl.includes('?') ? '&' : '?';
        transformedUrl += separator + param;
      }
    });

    // 4. Обработка exss={RID} (для link тоже нужно)
    if (!transformedUrl.includes('exss=')) {
      const separator = transformedUrl.includes('?') ? '&' : '?';
      transformedUrl += `${separator}exss={RID}`;
    }

    return transformedUrl;
  }

  // Если поле не link и не pixel, возвращаем как есть
  return transformedUrl;
}

export function transformAdriverJs(jscode: string, name: string): string {
  if (name !== 'js_code_audit') {
    return jscode;
  }

  // Проверяем, содержит ли код ссылку ad.adriver.ru/cgi-bin/json.cgi
  if (!jscode.includes('ad.adriver.ru/cgi-bin/json.cgi')) {
    return jscode;
  }

  // Находим URL внутри data-pixel атрибута
  const dataPixelMatch = jscode.match(/data-pixel="([^"]+)"/);

  if (!dataPixelMatch) {
    return jscode;
  }

  const originalUrl = dataPixelMatch[1];
  let transformedUrl = originalUrl;

  // 1. Замена exss с пустым значением на exss={RID}
  transformedUrl = transformedUrl.replace(/&exss=([^&]*)/g, (match, value) => {
    if (value === '' || value === '&' || value === undefined) {
      return '&exss={RID}';
    }
    return match;
  });

  // Если exss нет совсем, добавляем его
  if (!transformedUrl.includes('exss=')) {
    const separator = transformedUrl.includes('?') ? '&' : '?';
    transformedUrl += `${separator}exss={RID}`;
  }

  // 2. Замена rnd на rnd={RND}
  transformedUrl = transformedUrl.replace(/&rnd=([^&]*)/g, '&rnd={RND}');
  // Также заменяем rnd=!\[rnd\] если такой формат есть
  transformedUrl = transformedUrl.replace(/&rnd=!\\\[rnd\\\]/g, '&rnd={RND}');

  // 3. Добавление дополнительных параметров
  const additionalParams =
    '&exs0=mediasniper&exs1={PUBLISHER}&exs2={S_DMN_OR_APP_ENC}&exs3={SRC_XXH64}';

  // Проверяем, есть ли уже эти параметры
  if (!transformedUrl.includes('exs0=')) {
    transformedUrl += additionalParams;
  }

  // Заменяем исходный URL на преобразованный
  return jscode.replace(originalUrl, transformedUrl);
}

export function transformAdriverVastUrl(url: string, name: string): string {
  if (name !== 'data.vast_url') {
    return url;
  }

  if (!url.includes('ad.adriver.ru/cgi-bin/rle.cgi')) {
    return url;
  }

  try {
    // Разбиваем URL
    const [base, query = ''] = url.split('?');
    const params = new Map<string, string>();

    // Парсим существующие параметры
    if (query) {
      query.split('&').forEach((param) => {
        const [key, value = ''] = param.split('=');
        params.set(key, value);
      });
    }

    // Обновляем параметры
    if (
      params.has('exss') &&
      (!params.get('exss') || params.get('exss') === '')
    ) {
      params.set('exss', '{RID}');
    }

    if (params.has('rnd')) {
      params.set('rnd', '{RND}');
    }

    // Добавляем новые
    if (!params.has('exs0')) params.set('exs0', 'mediasniper');
    if (!params.has('erid')) params.set('erid', '{ERID}');
    if (!params.has('exs1')) params.set('exs1', '{PUBLISHER}');
    if (!params.has('exs2')) params.set('exs2', '{S_DMN_OR_APP_ENC}');
    if (!params.has('exs3')) params.set('exs3', '{SRC_XXH64}');
    if (!params.has('custom')) params.set('custom', '11={TR_KEY}');

    // Собираем обратно
    const queryString = Array.from(params.entries())
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    return `${base}?${queryString}`;
  } catch (error) {
    console.error('Error transforming Adriver VAST URL:', error);
    return url;
  }
}

export function transformAdriverEventPixelUrl(
  url: string,
  name: string,
): string {
  if (!pixelEventFields.includes(name)) {
    return url;
  }

  if (!url.includes('ev.adriver.ru/cgi-bin/event.cgi')) {
    return url;
  }

  try {
    const [base, query = ''] = url.split('?');
    if (!query) return url;

    const resultParams = query.split('&').map((param) => {
      const [key, value = ''] = param.split('=');

      if (key === 'exss') {
        return !value || value === 'null' || value === 'undefined'
          ? 'exss={RID}'
          : param;
      }

      if (key === 'rnd') {
        return /^\d+$/.test(value) ? 'rnd={RND}' : param;
      }

      return param;
    });

    return `${base}?${resultParams.join('&')}`;
  } catch (error) {
    console.error('Error transforming Adriver Event Pixel URL:', error);
    return url;
  }
}
